import { IDropdownOption } from "@fluentui/react";
import { createSelector } from "@reduxjs/toolkit";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DefaultConstant, syncCafeStatus } from "../../common/commonConstants";
import * as diningReducer from "../../reducers/diningReducer";
import * as diningSelector from "../../selectors/diningSelector";
import withAppInsights from "../AppInsights/AppInsights";
import CafeSelectorView from "./CafeSelectorView";

// Option selector construction, in order of appearance
const regionOptionsSelector = createSelector(diningSelector.regionListSelector, (regionList) =>
  regionList.map((region) => ({ key: region.id, text: region.name } as IDropdownOption)),
);

const cafeOptionsSelector = createSelector(diningSelector.syncCafeListSelector, (syncCafeList) =>
  syncCafeList.map((cafe) => ({ key: cafe.id, text: cafe.name } as IDropdownOption)),
);

export const CafeSyncSelector = () => {
  const regionOptions = useSelector(regionOptionsSelector);
  const cafeOptions = useSelector(cafeOptionsSelector);
  const selectedSyncCafe = useSelector(diningSelector.syncCafeSelector);
  const selectedSyncRegion = useSelector(diningSelector.syncRegionSelector);
  const syncCafeSelectorList = useSelector(diningSelector.syncCafeListSelector);

  const dispatch = useDispatch();

  // Fetches region list on initialization
  useEffect(() => {
    if (!regionOptions || regionOptions.length == 0) dispatch(diningReducer.fetchRegionsAsync());
  }, []);

  const onRegionSelect = (option?: IDropdownOption) => {
    if (option) {
      const region = regionOptions.find((obj) => obj.key === option.key.toString());
      if (region) {
        dispatch(diningReducer.setSelectedSyncRegionAsync(region.key.toString()));
      }
    }
    option && dispatch(diningReducer.fetchRegionSyncCafesAsync(option.key.toString(), DefaultConstant.AGILYSYS));
  };

  // Fires onChange of Cafe Selection Dropdown
  const onCafeSyncSelect = (option?: IDropdownOption) => {
    if (option) {
      dispatch(diningReducer.resetSyncCafeAndFlushCacheStatus(syncCafeStatus.IDLE));

      const cafe = syncCafeSelectorList.find((obj) => obj.id === option.key.toString());
      if (cafe) {
        dispatch(diningReducer.setSelectedSyncCafeAsync(cafe));
      }
    }
  };

  return (
    <CafeSelectorView
      regionOptions={regionOptions}
      cafeOptions={cafeOptions}
      onRegionSelect={onRegionSelect}
      onCafeSelect={onCafeSyncSelect}
      selectedRegionId={selectedSyncRegion ? selectedSyncRegion : ""}
      selectedCafeId={selectedSyncCafe?.id}
    />
  );
};

export default withAppInsights(CafeSyncSelector);
